import { axiosInterceptors } from '~/utils/axiosInterceptor'

class WarApi {
	constructor(axios, baseUrl) {
		this.axios = axios
		this.baseUrl = baseUrl
	}

	getWarDeeplink(matchSeriesId, token) {
		return this.axios.post(
			`${this.baseUrl}/create-war`,
			{
				matchSeriesId,
			},
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}

	getClanWarStatus(clanTag) {
		return this.axios.get(`${this.baseUrl}/clan/${encodeURIComponent(clanTag)}/war-status`)
	}

	setSelectedPlayers(token, clanTag, players) {
		return this.axios.post(
			`${this.baseUrl}/clan/${encodeURIComponent(clanTag)}/selected-players`,
			{ players },
			{
				headers: {
					Authorization: token,
				},
			}
		)
	}

	getSelectedPlayers(clanTag) {
		return this.axios.get(
			`${this.baseUrl}/clan/${encodeURIComponent(clanTag)}/selected-players`
		)
	}
}

export default ({ $axios, $config }, inject) => {
	const warApi = $axios.create()

	axiosInterceptors(warApi)
	inject('warApi', new WarApi(warApi, $config.warBaseUrl))
}
